const TOKEN = 'TOKEN'
const FOLIO_DIGITAL = 'FOLIO_DIGITAL'
const MEDIO_CONTACTO = 'MEDIO_CONTACTO'

const obtenerTokenStorage = () => {
  return JSON.parse(localStorage.getItem(TOKEN)) !== null
    ? `Bearer ${JSON.parse(localStorage.getItem(TOKEN))}`
    : `Bearer ${JSON.parse(localStorage.getItem(TOKEN))}`
}

const obtenerFolioDigitalStorage = () => {
  return localStorage.getItem(FOLIO_DIGITAL) !== null
    ? JSON.parse(localStorage.getItem(FOLIO_DIGITAL))
    : ''
}

const obtenerMedioContactoStorage = () => {
  return localStorage.getItem(MEDIO_CONTACTO) !== null
    ? JSON.parse(localStorage.getItem(MEDIO_CONTACTO))
    : '0'
}

const agregarTokenStorage = (token) => {
  localStorage.setItem(TOKEN, JSON.stringify(token))
}

const agregarFolioDigitalStorage = (folio) => {
  localStorage.setItem(FOLIO_DIGITAL, JSON.stringify(folio))
}

const agregarMedioContactoStorage = (m) => {
  localStorage.setItem(MEDIO_CONTACTO, JSON.stringify(m))
}

const eliminarTokenStorage = () => localStorage.removeItem(TOKEN)

const eliminarFolioDigitalStorage = () => localStorage.removeItem(FOLIO_DIGITAL)

const eliminarMedioContactoStorage = () =>
  localStorage.removeItem(MEDIO_CONTACTO)

export {
  obtenerTokenStorage,
  agregarTokenStorage,
  eliminarTokenStorage,
  obtenerFolioDigitalStorage,
  agregarFolioDigitalStorage,
  eliminarFolioDigitalStorage,
  obtenerMedioContactoStorage,
  agregarMedioContactoStorage,
  eliminarMedioContactoStorage,
}
